// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_logoss__a1ngv{
    width: 95px;
    margin: auto;
    /* margin-right: 10px; */
}


.sidebar_sidebarsec__qBU\\+3 {
    /* background: var(--sideclr); */
    background: var(--blackclr);
    height: 89vh;
    overflow: auto;
    position: relative;
    /* height: 100%; */
}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_logosec__l98Jt {
    padding: 40px;
    padding-top: 60px;
}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_logosec__l98Jt .sidebar_logoimg__U2E57 {
    width: 100%;
    height: 100%;

}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_dropmenu__xjS46 {
    background: none;
    border: none;
    display: flex;
    align-items: start;
    gap: 20px;
    flex-direction: column;
}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_iconrow__OFOS9 a {
    text-decoration: none;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_ulstyle__YC324 a {
    text-decoration: none;
    color: #fff;
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;


}
.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_ulstyle__YC324 a.sidebar_activemenus__SOPZt{
    color: #fff;
}

.sidebar_sidebarsec__qBU\\+3 .sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 {
    /* padding: 4vh 2vw; */
    padding: 4vh 1vw 4vh 0vw;
}

.sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 .sidebar_ulstyle__YC324 {
    padding-left: 0px;
    list-style-type: none;
}
.sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 .sidebar_ulstyle__YC324 li a{
    display: block;

    color: var(--whtclr);
    font-size: 1.7vh;
    font-weight: 400;
    /* background: url('../images/sidebarbtn.png') ;
    background-repeat: no-repeat;
    background-size: 100% 100% !important; */
    /* padding: 1.5vh 3vw; */
    text-align: left;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    padding: 2.4vh 1.5vh;
    border-radius: 0 50vh 50vh 0;
    border-left: 0.4vh solid transparent;
    white-space: nowrap;
}
.sidebar_iconimg__JNo-P{
    background: #d83d10;
    width: 3.2vh;
    height: 3.2vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50vh;
    margin-right: 0.8vh;
}
.sidebar_iconimg__JNo-P svg{
  font-size: 1.6vh;
}
.sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 .sidebar_ulstyle__YC324 li a[class="active"]{
    background: #2d699b;
    border-left: 0.4vh solid #0090e7;;
    /* background: url('../images/sidebaractivebtn.png') !important;
    background-size: 100% 100% !important; */
}
.sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 .sidebar_ulstyle__YC324 li{
    margin-bottom: 2vh;
    width: 16vw;
    /* height: 7vh; */
    height: 4vh;
}


.sidebar_menubar__w3\\+iv {
    height: 50px;
    padding: 10px 20px;
}

.sidebar_menubar__w3\\+iv svg {
    fill: #fff;
    font-size: 30px;
    position: absolute;

}

.sidebar_closeicons__gh0Mp svg {
    fill: #fff;
    font-size: 20px;
    position: absolute;
    top: 10px;
    right: 15px;

}


@media screen and (max-width: 1199px) {
    .sidebar_sidebarsec__qBU\\+3.sidebar_mobilemenu__vl87l {
        position: fixed;
        width: 270px;
        display: none;
        top: 0px;
        z-index: 999;
        right: 0px;
        height: 100vh;
    }

    .sidebar_sidebarsec__qBU\\+3.sidebar_mobilemenu__vl87l.sidebar_mobilemenuopen__tq0m4 {
        display: block;
    }
    .sidebar_siderow__iMQI1 .sidebar_menulist__ZKUC2 .sidebar_ulstyle__YC324 li{
        width: 90%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;;AAGA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;;AAGpB;AACA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,cAAc;;IAEd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB;;4CAEwC;IACxC,wBAAwB;IACxB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,4BAA4B;IAC5B,oCAAoC;IACpC,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;IACI,mBAAmB;IACnB,gCAAgC;IAChC;4CACwC;AAC5C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;;AAEf;;;AAGA;IACI;QACI,eAAe;QACf,YAAY;QACZ,aAAa;QACb,QAAQ;QACR,YAAY;QACZ,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".logoss{\n    width: 95px;\n    margin: auto;\n    /* margin-right: 10px; */\n}\n\n\n.sidebarsec {\n    /* background: var(--sideclr); */\n    background: var(--blackclr);\n    height: 89vh;\n    overflow: auto;\n    position: relative;\n    /* height: 100%; */\n}\n\n.sidebarsec .siderow .logosec {\n    padding: 40px;\n    padding-top: 60px;\n}\n\n.sidebarsec .siderow .logosec .logoimg {\n    width: 100%;\n    height: 100%;\n\n}\n\n.sidebarsec .siderow .dropmenu {\n    background: none;\n    border: none;\n    display: flex;\n    align-items: start;\n    gap: 20px;\n    flex-direction: column;\n}\n\n.sidebarsec .siderow .iconrow a {\n    text-decoration: none;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n\n}\n\n.sidebarsec .siderow .ulstyle a {\n    text-decoration: none;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n\n\n}\n.sidebarsec .siderow .ulstyle a.activemenus{\n    color: #fff;\n}\n\n.sidebarsec .siderow .menulist {\n    /* padding: 4vh 2vw; */\n    padding: 4vh 1vw 4vh 0vw;\n}\n\n.siderow .menulist .ulstyle {\n    padding-left: 0px;\n    list-style-type: none;\n}\n.siderow .menulist .ulstyle li a{\n    display: block;\n\n    color: var(--whtclr);\n    font-size: 1.7vh;\n    font-weight: 400;\n    /* background: url('../images/sidebarbtn.png') ;\n    background-repeat: no-repeat;\n    background-size: 100% 100% !important; */\n    /* padding: 1.5vh 3vw; */\n    text-align: left;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    padding: 2.4vh 1.5vh;\n    border-radius: 0 50vh 50vh 0;\n    border-left: 0.4vh solid transparent;\n    white-space: nowrap;\n}\n.iconimg{\n    background: #d83d10;\n    width: 3.2vh;\n    height: 3.2vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50vh;\n    margin-right: 0.8vh;\n}\n.iconimg svg{\n  font-size: 1.6vh;\n}\n.siderow .menulist .ulstyle li a[class=\"active\"]{\n    background: #2d699b;\n    border-left: 0.4vh solid #0090e7;;\n    /* background: url('../images/sidebaractivebtn.png') !important;\n    background-size: 100% 100% !important; */\n}\n.siderow .menulist .ulstyle li{\n    margin-bottom: 2vh;\n    width: 16vw;\n    /* height: 7vh; */\n    height: 4vh;\n}\n\n\n.menubar {\n    height: 50px;\n    padding: 10px 20px;\n}\n\n.menubar svg {\n    fill: #fff;\n    font-size: 30px;\n    position: absolute;\n\n}\n\n.closeicons svg {\n    fill: #fff;\n    font-size: 20px;\n    position: absolute;\n    top: 10px;\n    right: 15px;\n\n}\n\n\n@media screen and (max-width: 1199px) {\n    .sidebarsec.mobilemenu {\n        position: fixed;\n        width: 270px;\n        display: none;\n        top: 0px;\n        z-index: 999;\n        right: 0px;\n        height: 100vh;\n    }\n\n    .sidebarsec.mobilemenu.mobilemenuopen {\n        display: block;\n    }\n    .siderow .menulist .ulstyle li{\n        width: 90%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoss": `sidebar_logoss__a1ngv`,
	"sidebarsec": `sidebar_sidebarsec__qBU+3`,
	"siderow": `sidebar_siderow__iMQI1`,
	"logosec": `sidebar_logosec__l98Jt`,
	"logoimg": `sidebar_logoimg__U2E57`,
	"dropmenu": `sidebar_dropmenu__xjS46`,
	"iconrow": `sidebar_iconrow__OFOS9`,
	"ulstyle": `sidebar_ulstyle__YC324`,
	"activemenus": `sidebar_activemenus__SOPZt`,
	"menulist": `sidebar_menulist__ZKUC2`,
	"iconimg": `sidebar_iconimg__JNo-P`,
	"menubar": `sidebar_menubar__w3+iv`,
	"closeicons": `sidebar_closeicons__gh0Mp`,
	"mobilemenu": `sidebar_mobilemenu__vl87l`,
	"mobilemenuopen": `sidebar_mobilemenuopen__tq0m4`
};
export default ___CSS_LOADER_EXPORT___;
